




























































































































































































































































































































































  import { Component, Watch, mixins, State, Vue } from 'nuxt-property-decorator'
  import LazyHydrate from 'vue-lazy-hydration'
  import { namespace } from 'vuex-class'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { Account, PaymentMethod, Products, Orderpath } from '@one/types'
  import { Cart, Shared } from '@one/types/dist/orderpath/app'
  import isEmpty from 'lodash/isEmpty'
  import { LocaleMessages } from 'vue-i18n'
  import { MutationPayload } from 'vuex/types/index'
  import { PaymentMethodType } from '@one/types/dist/orderpath/app/shared'
  import pages from '../breadcrumbs'
  import AddToCartMixin from '../../mixins/AddToCartMixin'
  import UtilsMixin from '../../mixins/UtilsMixin'
  import {
    AwardProductChanged,
    AwardsUpdateEvent,
  } from '~/components/molecules/modals/OneCampaignModal.vue'
  import { ProductItem } from '~/plugins/gtm/gtm'
  import { getProductKeyAttribute } from '~/store/cart/utils'
  import { EditProductLinesOnCartContext } from '~/plugins/sdk/EditProductLinesOnCartContext'
  import useQuantityUtils from '~/composables/useQuantityUtils'
  import usePragmaPayUtils from '~/composables/usePragmaPayUtils'

  const cart: BindingHelpers = namespace('cart')
  const stocks: BindingHelpers = namespace('stocks')
  const layout: BindingHelpers = namespace('layout')
  const account: BindingHelpers = namespace('account')
  interface IMixinInterface extends AddToCartMixin, UtilsMixin {}
  interface ValidationQuantity {
    valid?: boolean
    productId?: string
    quantity?: number
  }
  interface ProductsToRemove {
    productId: string
    productLineId?: string
  }

  @Component({
    name: 'Cart',
    middleware: ['isAuthenticatedOrPurchaseEnabled'],
    meta: {
      breadcrumb: {
        name: pages.CART,
        link: '/cart',
      },
    },
    components: {
      OneExternalPaymentLimitsBanner: () => import('~/components/molecules/banners/OneExternalPaymentLimitsBanner.vue'),
      OneCartSaving: () => import('~/components/organisms/cart/OneCartSaving.vue'),
      OneCampaignModal: () => import('~/components/molecules/modals/OneCampaignModal.vue'),
      OneCartAwardCampaignsList: () =>
        import('~/components/organisms/cart/OneCartAwardCampaignsList.vue'),
      OneProgressStepsCheckout: () =>
        import('~/components/organisms/orderpath/OneProgressStepsCheckout.vue'),
      OneCartShipmentList: () => import('~/components/organisms/cart/OneCartShipmentList.vue'),
      OneRfqBanner: () => import('~/components/molecules/banners/OneRfqBanner.vue'),
      OneSummaryTable: () => import('~/components/organisms/orderpath/OneSummaryTable.vue'),
      OneProductsList: () => import('~/components/organisms/list/OneProductsList.vue'),
      OneCartProductRow: () => import('~/components/organisms/orderpath/OneCartProductRow.vue'),
      OneCartProductRowMobileTile: () =>
        import('~/components/organisms/orderpath/mobile/OneCartProductRowMobile.vue'),
      OneCartShipment: () => import('~/components/organisms/orderpath/OneCartShipment.vue'),
      OneIconLoader: () => import('~/components/molecules/icons/OneIconLoader.vue'),
      OneCartModalLogin: () => import('~/components/organisms/auth/OneCartModalLogin.vue'),
      OneCartModalAdd: () => import('~/components/molecules/modals/OneCartModalAdd.vue'),
      OneCartModalDelete: () => import('~/components/molecules/modals/OneCartModalDelete.vue'),
      OneCartModalImport: () => import('~/components/molecules/modals/OneCartModalImport.vue'),
      OneCartModalRename: () => import('~/components/molecules/modals/OneCartModalRename.vue'),
      OneCartShipmentProduct: () =>
        import('~/components/molecules/carts/OneCartShipmentProduct.vue'),
      OneCartSummary: () => import('~/components/organisms/cart/OneCartSummary.vue'),
      OneCampaigns: () => import('~/components/organisms/cart/OneCampaigns.vue'),
      OneCartWishlistOptionsContainer: () =>
        import('~/components/molecules/carts/OneCartWishlistOptionsContainer.vue'),
      OneCartWishlistOptionsDropdown: () =>
        import('~/components/molecules/dropdowns/OneCartWishlistOptionsDropdown.vue'),
      OneFakeShipment: () => import('~/components/organisms/fake/OneFakeShipment.vue'),
      OneSelect: () => import('~/components/molecules/selects/OneSelect.vue'),
      OneSplitShipmentsBox: () => import('~/components/molecules/boxes/OneSplitShipmentsBox.vue'),
      OneCartPaymentMethods: () =>
        import('~/components/organisms/orderpath/OneCartPaymentMethods.vue'),
      LazyHydrate,
    },
  })
  export default class Index extends mixins<IMixinInterface>(AddToCartMixin, UtilsMixin) {
    @State isAppLoaded!: boolean
    @State isOrderpathLoaded!: boolean
    @cart.Getter getCartProductsKeys: any
    @cart.Getter getCartProducts: any
    @cart.Getter getPaymentMethodsArray: any
    @cart.Getter getCurrentCartId: any
    @cart.Getter getCurrentCart: any
    @cart.Getter getCartProduct: any
    @cart.Getter getBasicCarts: any
    @cart.Getter getCartById: any
    @cart.Getter getBasicCartById: any
    @cart.Getter getCurrentCredit: any
    @cart.Getter getShipmentById: any
    @cart.Getter getPaymentMethodById: any
    @cart.Getter getCartProductPrice: any
    @cart.Getter getTotalProductCountInCart: any
    @cart.Getter getPrices: any
    @cart.Getter isAllShipmentsValid!: boolean
    @cart.Getter isCheckoutAsGuest!: boolean
    @cart.Getter getCartParentProductsKeys!: any
    @cart.Action fetchCurrentCart: any
    @cart.Action fetchPaymentsAndDeliveryMethods: any
    @cart.Action refetchCart: any
    @cart.Action setPaymentMethod: any
    @cart.Action removeProductFromCart: any
    @cart.Action removeSelectedProducts: any
    @cart.Action changeOrderOfItemsInCart: any
    @cart.Action setCartComments: any
    @cart.Action createCheckoutForCart: any
    @cart.Action renameCart: any
    @cart.Action removeCart: any
    @cart.Action createCart: any
    @cart.Action fetchPaymentMethods: any
    @cart.Action fetchDeliveryMethods: any
    @cart.Action setSplitChoice: any
    @cart.Mutation('RESET_SHIPMENTS_VALIDITY_MAP') resetShipmentsValidityMap: any
    @account.Action fetchTradeCreditForPayer!: any
    @stocks.Getter getDefaultWarehouseId: any
    @stocks.Getter getWarehouse: any
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any
    @account.Getter getCustomerType: any
    @account.Getter tradeCredit!: Account.App.Responses.TradeCredit
    @account.Getter getClient: any

    hoverImportOrExport: boolean = false
    selectedImport: boolean = false
    selectedPaymentMethod: string | null = null
    showRenameModal: boolean = false
    showDeleteModal: boolean = false
    showCreateModal: boolean = false
    showImportCartModal: boolean = false
    showImportErrorBanner: boolean = false
    showCampaignModal: boolean = false
    activeCampaignId: string | null = null
    importErrorData: Array<Cart.Responses.ParseError> | Array<void> = []
    loading: boolean = false
    storeSubscription: Function | null = null
    showLoginModal: boolean = false
    selectedAwardsAmount: number = 0
    mainComponentClass = 'one-cart-page'
    validQuantity: ValidationQuantity = {}
    quantityMath = useQuantityUtils(1e-9)
    pragmaPayUtils = usePragmaPayUtils()

    openCampaignModal(campaign: Shared.CartAwardCampaign) {
      this.activeCampaignId = campaign.campaignId
      this.selectedAwardsAmount = campaign.selected
      this.showCampaignModal = true
    }

    translateLabel(key: string, args?: Array<any>): string {
      return (this.$t(`cart.import_errors.${key.toLowerCase()}`, args) as string) || key
    }

    fetch({ app, store }: any) {
      app.wait.initialized && app.wait.start('loading-cart')
      store.commit('layout/TOGGLE_BREADCRUMBS', false)
    }

    mounted() {
      this.scrollTop(0)
      this.storeSubscription = this.$store.subscribe(this.storeMutationHandler)
      if (this.isAppLoaded) {
        this.onAppLoaded()
        this.onOrderpathLoadingChange(true)
      }
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    @Watch('isOrderpathLoaded')
    async onOrderpathLoadingChange(isLoaded: boolean) {
      if (isLoaded) {
        await this.currentCartChanged(this.getCurrentCartId)
        this.selectedPaymentMethod =
          (this.getCurrentCart && this.getCurrentCart.paymentMethodId) || null
      }
    }

    @Watch('isAppLoaded')
    onAppLoaded() {
      this.$watch('getCurrentCartId', this.currentCartChanged)
      this.$watch('getDefaultWarehouseId', this.onWarehouseChanged)
      this.$wait.end('loading-cart')
      this.$plugins.onMounted(this.mainComponentClass, this)
    }

    @Watch('getPaymentMethodsArray', { immediate: true })
    onPaymentMethodsChanged() {
      if (!this.getPaymentMethodsArray.find((method) => method.id === this.selectedPaymentMethod)) {
        this.selectedPaymentMethod = null
      }
    }

    beforeRouteEnter(to, from, next) {
      if (from.name !== 'checkout-order-summary' && from.name !== 'checkout-address') {
        Vue.set(to.params, 'sendWebhook', true)
      }
      return next()
    }

    async onWarehouseChanged(warehouseId: string) {
      if (warehouseId === this.cart?.contextWarehouseId) {
        return
      }
      try {
        const currentCart: Cart.Responses.Cart = await this.fetchCurrentCart()
        await this.fetchPaymentsAndDeliveryMethods(currentCart)
      } catch {
        await this.refetchCart()
      }
      this.selectedPaymentMethod = null
    }

    async currentCartChanged(cartId: string | null) {
      if (!cartId) {
        return
      }
      try {
        if (this.$auth.isAuthenticated) {
          this.$api.webhooks.app.publishCartOpened({
            cartId: cartId,
            clientExternalId: this.getClient.externalId,
          })
        }
        const products = Array.from(
          this.getCartProducts(this.getCurrentCartId).values() as Array<Shared.ProductInCart>,
        ).map((p, index) => {
          return {
            item_id: p.id,
            item_name: p.name,
            item_brand: p.manufacturer.name,
            item_url: p.url,
            item_image: p.photo,
            item_gtin: p.catalogIndex,
            item_mpn: p.manufacturerIndex,
            price: p.prices?.net,
            quantity: p.shipments.reduce((acc, shipment) => acc + shipment.numberOfProducts, 0),
            category: this.$routes.getCategoryPath(p.canonicalCategory) || '',
            coupon: p.appliedCampaigns.map((campaign) => campaign.name).join(','),
            discount: p.prices?.basePriceDiscount,
            index: index,
          }
        })
        if (products.length) {
          this.$gtm.checkout(
            products,
            this.getCurrentCart.prices?.totalNet || 0,
            this.selectedPaymentMethod,
            null,
            this.getCurrentCart?.appliedCampaigns?.map((campaign) => campaign.name).join(','),
          )
        }
        this.importErrorData = []
        this.$orderpath.cart.fetchAdditionalCosts()
        this.fetchDeliveryMethodsAndPaymentMethods()
      } catch (err) {
        this.$logger.warn(err)
        await this.refetchCart()
      }
    }

    get awardCampaigns(): Array<Shared.CartAwardCampaign> {
      return this.cart?.awardCampaigns ?? []
    }

    get cartUserForAuthorization(): Shared.OriginalUser | null {
      return (this.getCurrentCart && this.getCurrentCart.originalUser) || null
    }

    get isDisabled(): boolean | null {
      return (this.isTradeCredit && !this.isEnoughTradeCredit) || this.$wait.is('loading-cart')
    }

    get isCartEmpty() {
      return (
        !this.getCurrentCart ||
        (this.getCurrentCart.products ? this.getCurrentCart.products.size < 1 : true)
      )
    }

    get isEnoughTradeCredit() {
      const currentCart = this.getCurrentCart
      const cartValue = currentCart && currentCart.prices && currentCart.prices.totalGross
      if (!this.tradeCredit?.availableCreditValue) {
        return false
      }
      return cartValue < this.tradeCredit?.availableCreditValue
    }

    get isEnoughPragmaPayLimit() {
      const currentCart = this.getCurrentCart
      const cartValue = currentCart && currentCart.prices && currentCart.prices.totalGross * 100
      return !this.pragmaPayUtils.isLimitAmountReached(cartValue)
    }

    get isTradeCredit(): boolean | null {
      const currentPaymentMethod: PaymentMethod | null = this.getPaymentMethodById(
        this.getCurrentCartId,
        this.selectedPaymentMethod,
      )
      return currentPaymentMethod && currentPaymentMethod.type === PaymentMethodType.TRADE_CREDIT
    }

    get isSimplePay(): boolean | null {
      const currentPaymentMethod: PaymentMethod | null = this.getPaymentMethodById(
        this.getCurrentCartId,
        this.selectedPaymentMethod,
      )
      return currentPaymentMethod && currentPaymentMethod.type === PaymentMethodType.SIMPLEPAY
    }

    get isPragmaPay(): boolean | null {
      const currentPaymentMethod: PaymentMethod | null = this.getPaymentMethodById(
        this.getCurrentCartId,
        this.selectedPaymentMethod,
      )
      return currentPaymentMethod && currentPaymentMethod.type === PaymentMethodType.PRAGMAPAY
    }

    get cart(): Cart.Responses.Cart | null {
      return this.getCartById(this.getCurrentCartId)
    }

    // TODO: to tu nie jest potrzebne
    get selectableCarts() {
      return Object.keys(this.getBasicCarts).map((basicCartId: string) => {
        if (this.getBasicCartById(basicCartId)) {
          return {
            label: this.getBasicCartById(basicCartId).name,
            value: basicCartId,
            sentForAuthorization: isEmpty(this.getBasicCartById(basicCartId).originalUser),
          }
        }
        return undefined
      })
    }

    // TODO: to tu nie jest potrzebne
    get currentCartForSelect() {
      return {
        label: this.getCurrentCart.name,
        value: this.getCurrentCartId,
      }
    }

    get totalNoOfProducts() {
      const productsFromStore = this.getCartProducts(this.getCurrentCartId)
      if (productsFromStore.size < 1) {
        return 0
      }
      return Array.from(productsFromStore.values() as Array<Shared.ProductInCart>)
        .map((o: Shared.ProductInCart) =>
          o.shipments
            .map((shipment: any) => shipment.numberOfProducts)
            .reduce(this.additiveReducer),
        )
        .reduce(this.additiveReducer)
    }

    get isSplitShipmentActive(): boolean {
      return this.getCurrentCart.containsIgnorableSplitRules
    }

    get tradeCreditData(): Object | null {
      if (this.isTradeCredit) {
        return this.tradeCredit
      }
      return null
    }

    get selectedPaymentDescription(): string {
      const pm: PaymentMethod | null = this.getPaymentMethodById(
        this.getCurrentCartId,
        this.selectedPaymentMethod,
      )
      return pm ? pm.description : ''
    }

    // TODO: Util aktualnego koszyka
    get selectedPaymentType(): PaymentMethodType | string {
      const pm: PaymentMethod | null = this.getPaymentMethodById(
        this.getCurrentCartId,
        this.selectedPaymentMethod,
      )
      return pm ? pm.type : ''
    }

    // TODO: Util aktualnego koszyka
    get hasProducts() {
      const hasProducts: Map<string, Shared.ProductInCart> | null = this.getCartProducts(
        this.getCurrentCartId,
      )
      return hasProducts && hasProducts.size > 0
    }

    get isCartFetching() {
      return this.$wait.is(`cart-${this.getCurrentCartId}-fetching`)
    }

    get isPaymentMethodUpdating() {
      return this.$wait.is(`cart-${this.getCurrentCartId}-payment-methods-updating`)
    }

    get isDeliveryMethodUpdating() {
      return this.$wait.is([
        `cart-${this.getCurrentCartId}-delivery-methods-fetching`,
        'setting-delivery-method',
      ])
    }

    // TODO: Util aktualnego koszyka
    get clientHasBlockade(): boolean {
      return !!this.getCurrentCart.accountBlockadeType
    }

    get blockadeMessage(): string | LocaleMessages | null {
      switch (this.getCurrentCart.accountBlockadeType) {
        case 'TRADE_CREDIT': {
          return this.$t('cart.blockades.trade_credit') as string
        }
        case 'SALE': {
          return this.$t('cart.blockades.sale') as string
        }
        case 'CLIENT': {
          return this.$t('cart.blockades.client') as string
        }
        default: {
          return null
        }
      }
    }

    get checkResolution(): boolean {
      return this.$utils.isMobileOrTablet(this.$mq)
    }

    get mainProducts(): Array<string> {
      return this.getCartParentProductsKeys(this.getCurrentCartId)
    }

    get totalPrice(): number | null {
      const prices = this.getPrices(this.getCurrentCart.prices, this.isGrossSelected)
      return prices?.products || null
    }

    async fetchDeliveryMethodsAndPaymentMethods() {
      if (!this.getCurrentCart) {
        return
      }
      try {
        this.resetShipmentsValidityMap()
        await this.fetchDeliveryMethods({
          warehouseId: this.getDefaultWarehouseId,
          shipmentsIds: Object.keys(this.getCurrentCart.shipments),
          cartId: this.getCurrentCartId,
        })
        if (this.$auth.isAuthenticated) {
          this.fetchTradeCreditForPayer()
        }
        this.fetchPaymentMethods({
          warehouseId: this.getDefaultWarehouseId,
          cartId: this.getCurrentCartId,
        })
      } catch (e) {
        this.$logger.warn(e)
      }
    }

    mouseActionImport(value: boolean) {
      this.hoverImportOrExport = value
      this.selectedImport = value
    }

    mouseActionExport(value: boolean) {
      this.hoverImportOrExport = value
    }

    getProductAvailability(productId: string) {
      const shipments: Array<any> = []
      this.getProductCart(productId).shipments.forEach((shipment: any) => {
        const shipmentFrom = this.getShipmentById(this.getCurrentCartId, shipment.shipmentId)
        shipments.push({
          id: shipmentFrom.id,
          productAvailability: shipmentFrom.productAvailability,
          numberOfProducts: shipment.numberOfProducts,
          contextWarehouseType: this.getWarehouse(shipmentFrom.contextWarehouseId).type,
        })
      })
      return shipments
    }

    async selectSplitOption(event: string) {
      this.$api.orderpath.app.invalidate(['carts'])
      try {
        await this.setSplitChoice({
          cartId: this.$orderpath.cart.currentCartId,
          splitChoice: event,
        })
        await this.$orderpath.cart.fetchCart(this.$orderpath.cart.currentCartId)
        await this.fetchDeliveryMethodsAndPaymentMethods()
      } catch {
        await this.refetchCart()
      }
    }

    notEnoughTradeCreditAlert() {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('cart.trade_credit_error') as string,
      })
    }

    notEnoughPragmaPayLimitAlert() {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('cart.pragmapay_limit_error') as string,
      })
    }

    emptyCartAlert() {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('cart.empty_cart_error') as string,
      })
    }

    noDeliveryMethodSelectedAlert() {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('cart.no_delivery_method_selected') as string,
      })
    }

    noPaymentMethodSet() {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('cart.no_payment_method_set') as string,
      })
    }

    // TODO: Util aktualnego koszyka
    get notAvailableProducts(): Array<Shared.ProductInCart> | [] {
      return this.getCartProductsKeys(this.getCurrentCartId)
        .map((x: string) => this.getProductCart(x))
        .filter((x: Shared.ProductInCart) => x.labels.includes('Block'))
        .filter((x: Shared.ProductInCart) => this.checkIfProductIsAvailable(x))
    }

    // TODO: Util aktualnego koszyka
    get hasNotAvailableProducts(): boolean {
      return !!this.notAvailableProducts.length
    }

    // TODO: Util aktualnego koszyka
    get cartValueWithDeliveryAndAdditionalCost(): number | null {
      const prices = this.getPrices(this.getCurrentCart.prices, false)
      if (!prices) {
        return null
      }
      const totalAdditionalCostNet =
        prices &&
        prices.additionalCosts.length &&
        prices.additionalCosts
          .map((elem: { total: number }) => elem.total)
          .reduce(this.additiveReducer)
      return (
        this.getCurrentCart.prices.productsNet +
        this.getCurrentCart.prices.deliveryTypesNet +
        (totalAdditionalCostNet || 0)
      )
    }

    // TODO: Util aktualnego koszyka
    checkIfProductIsAvailable(p: Shared.ProductInCart) {
      const quantity = p.parentWarehouseQuantity
        ? p.parentWarehouseQuantity + p.warehouseQuantity
        : p.warehouseQuantity
      return quantity < this.getTotalProductCountInCart(p.id, this.getCurrentCartId)
    }

    informationIfSomeProductsAreNotAvailable(p: Shared.ProductInCart) {
      const quantity = p.parentWarehouseQuantity
        ? p.parentWarehouseQuantity + p.warehouseQuantity
        : p.warehouseQuantity
      return `${p.name} - ${this.$t(
        'cart.some_products_are_not_available_one',
      )} ${quantity} / ${this.$t(
        'cart.some_products_are_not_available_two',
      )} ${this.getTotalProductCountInCart(p.id, this.getCurrentCartId)}`
    }

    storeMutationHandler(mutation: MutationPayload) {
      if (
        ['cart/ADD_ITEM_TO_CART', 'cart/REMOVE_ITEM_FROM_CART', 'cart/SET_CART'].includes(
          mutation.type,
        )
      ) {
        this.fetchDeliveryMethodsAndPaymentMethods()
      }
    }

    beforeDestroy() {
      if (this.storeSubscription) {
        this.storeSubscription()
      }
    }

    onCheckoutAsGuest() {
      this.onLoginModalHide()
      this.createCheckout()
    }

    createCheckout() {
      if (!this.$auth.isAuthenticated && !this.isCheckoutAsGuest) {
        this.showLoginModal = true
        return Promise.resolve()
      }
      if (this.totalNoOfProducts < 1) {
        return this.emptyCartAlert()
      }
      if (this.isTradeCredit) {
        if (!this.isEnoughTradeCredit) {
          return this.notEnoughTradeCreditAlert()
        }
      }
      if (!this.isAllShipmentsValid) {
        return this.noDeliveryMethodSelectedAlert()
      }
      if (!this.selectedPaymentMethod) {
        return this.noPaymentMethodSet()
      }
      try {
        return this.createCheckoutForCart(this.getCurrentCartId).then((checkoutId: string) => {
          if (checkoutId) {
            this.$gtm.checkoutOption(1, `paymentMethod: ${this.selectedPaymentMethod}`)
            if (this.isCheckoutAsGuest) {
              this.$router.push({
                path: `${this.localePath('checkout-guest')}/address`,
                query: {
                  checkoutId,
                },
              })
            } else {
              this.$router.push({
                path: `${this.localePath('checkout')}/address`,
                query: {
                  checkoutId,
                },
              })
            }
          } else {
            this.$logger.warn('no checkoutId after creating checkout for cart')
          }
        })
      } catch (err: any) {
        if (err.response?.type === 'PAYMENT_METHOD_NOT_SET') {
          this.noPaymentMethodSet()
        }
        this.$logger.warn('err when creating checkout', err)
        return Promise.resolve()
      }
    }

    async onCartDetailsUpdate(value: { cartNotesValue: string; orderNumberValue: string }) {
      const newComments: Cart.Requests.SetCartCommentsOption = {
        notes: value.cartNotesValue,
        purchaseOrderNumber: value.orderNumberValue,
      }
      await this.setCartComments({
        cartId: this.getCurrentCartId,
        comments: newComments,
      })
      // this.$orderpath.cart.fetchCart(this.getCurrentCartId)
    }

    getProductCart(productId: string) {
      // FIXME: To chyba można ładniej zrobić
      return this.getCartProduct(this.getCurrentCartId)(productId)
    }

    getProductUnit(productId: string) {
      return this.getCartProduct(this.getCurrentCartId)(productId).measurementUnits
        .orderUnitDescription
    }

    getProductCentralWarehouseQty(productId: string) {
      return this.getCartProduct(this.getCurrentCartId)(productId).parentWarehouseQuantity
    }

    getProductSelectedWarehouseQty(productId: string) {
      return this.getCartProduct(this.getCurrentCartId)(productId).warehouseQuantity
    }

    onPaymentMethodSelected(value: string | null) {
      this.setPaymentMethod({
        cartId: this.getCurrentCartId,
        paymentMethodId: value,
        warehouseId: this.getDefaultWarehouseId,
      })
        .then(() => {
          this.$orderpath.cart.fetchCart(this.getCurrentCartId)
          this.selectedPaymentMethod = value
        })
        .catch(() => {
          this.selectedPaymentMethod = null
        })
    }

    additiveReducer = (accumulator: number, currentValue: number) =>
      this.quantityMath.roundToStepPrecision(accumulator + currentValue)

    onDragEnd(newMainProductsOrdering: Array<string>) {
      const allProducts = newMainProductsOrdering
        .map((productId: string) => {
          const children = [...this.cart!.products.values()]
            .map((product: Shared.ProductInCart) => {
              const attr = getProductKeyAttribute(product)
              if (product.parent === productId) {
                return product[attr]
              }
              return null
            })
            .filter((x) => x)
          return [productId, ...children]
        })
        .flat()
      this.changeOrderOfItemsInCart({
        cartId: this.getCurrentCartId,
        newOrder: {
          productIds: allProducts,
        },
      })
    }

    async onProductCountChange({
      amount,
      productLineId,
      productId,
    }: {
      amount: number
      productId: string
      productLineId: string | null
    }) {
      const product: Shared.ProductInCart = this.getProductCart(productLineId ?? productId)
      const currentNumberOfProduct: number = product.shipments
        .map((shipment: any) => shipment.numberOfProducts)
        .reduce(this.additiveReducer)
      const catalogProduct: Products.Product | null = await this.getOrFetchProduct(product.id)
      if (!catalogProduct) {
        return
      }
      const productsQty = product.shipments
        .map((shipment: any) => shipment.numberOfProducts)
        .reduce(this.additiveReducer)
      const productQuantityDiff: number = amount - productsQty
      if (productQuantityDiff === 0) {
        return
      }
      const { name, id, manufacturer, canonicalCategory, brand } = product
      if (productQuantityDiff < 0) {
        this.$gtm.productNewRemove(
          {
            item_id: id,
            item_name: name,
            item_brand: brand?.name || '',
            category: this.$routes.getCategoryPath(canonicalCategory) || '',
            price: product.prices?.net || 0,
            discount: product.prices?.basePriceDiscount || 0,
            quantity: productQuantityDiff,
          } as ProductItem,
          product.prices?.lineNet || 0,
        )
      } else {
        this.$gtm.productAdd({
          item_name: name,
          item_id: id,
          item_brand: (brand && brand.name) || manufacturer.name,
          category: this.$routes.getCategoryPath(canonicalCategory) || '',
          quantity: productQuantityDiff,
          price: product.prices?.net || 0,
          discount: product.prices?.basePriceDiscount || 0,
        })
      }
      this.$orderpath.cart
        .changeNumberOfProduct(this.getCurrentCartId, this.getDefaultWarehouseId, {
          productId,
          productLineId: product.productLineId,
          numberOfProducts: amount,
        })
        .catch(() => {
          this.validQuantity = {
            quantity: currentNumberOfProduct,
            productId: product.id,
            valid: false,
          }
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('cart.invalid_quantity_message') as string,
          })
        })
        .finally(() => {
          this.$orderpath.cart.fetchCart(this.getCurrentCartId)
        })
    }

    onProductRemove(productId: Shared.ProductId) {
      const product: Shared.ProductInCart = this.getProductCart(
        productId.productLineId ?? productId.productId,
      )
      if (!this.loading) {
        this.loading = true
        this.removeProductFromCart({
          cartId: this.getCurrentCartId,
          productId: {
            productId: product.id,
            productLineId: product.productLineId,
          },
        })
          .then(() => {
            this.$gtm.productNewRemove(
              {
                item_name: product.name,
                item_id: product.id,
                item_brand: (product.brand && product.brand.name) || product.manufacturer.name,
                category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
                price: product.prices?.basePriceNet ?? 0,
                discount: product.prices?.basePriceDiscount ?? 0,
                quantity: product.shipments
                  .map((shipment: any) => shipment.numberOfProducts)
                  .reduce(this.additiveReducer),
              } as ProductItem,
              product.prices?.lineNet,
            )
          })
          .finally(() => {
            this.loading = false
          })
      }
    }

    onCartChanged(cartId: string) {
      this.showImportErrorBanner = false
      this.$orderpath.cart.selectCart(cartId)
    }

    onCartRename(name: string) {
      this.$wait.start('cart-renaming')
      this.$orderpath.cart.renameCart(name).then(() => {
        this.showRenameModal = false
        this.$notify({
          group: 'alert',
          type: 'success',
          text: this.$t('cart.modals.cart_renamed') as string,
        })
        setTimeout(() => {
          this.$wait.end('cart-renaming')
        }, 150)
      })
    }

    onCartCreate(name: string) {
      this.$wait.start('cart-creating')
      this.$orderpath.cart.createCartAndSelect(name).then(() => {
        this.showCreateModal = false
        this.selectedPaymentMethod =
          (this.getCurrentCart && this.getCurrentCart.paymentMethodId) || null
        this.$notify({
          group: 'alert',
          type: 'success',
          text: this.$t('cart.modals.cart_created') as string,
        })
        setTimeout(() => {
          this.$wait.end('cart-creating')
        }, 150)
      })
    }

    onCartImport(file: FormData) {
      this.$wait.start('cart-importing')
      this.$api.orderpath.app
        .importProductsFromCart(file, this.getCurrentCartId)
        .then(async ({ data }: any) => {
          await this.$orderpath.cart.fetchCart(this.getCurrentCartId)
          this.fetchDeliveryMethodsAndPaymentMethods()
          this.showImportCartModal = false
          if (data.length > 0) {
            this.showImportErrorBanner = true
            this.importErrorData = data
            this.$notify({
              group: 'alert',
              type: 'error',
              text: this.$t('cart.modals.error_import_product') as string,
            })
          } else {
            this.$notify({
              group: 'alert',
              type: 'success',
              text: this.$t('cart.modals.success_import_product') as string,
            })
          }
          this.$wait.end('cart-importing')
        })
        .catch(() => {
          this.$wait.end('cart-importing')
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('cart.modals.error_import_product') as string,
          })
        })
    }

    onCartExport() {
      this.$api.orderpath.app
        .exportProductsFromCart(
          this.getDefaultWarehouseId,
          this.getCurrency.code,
          this.getCurrentCartId,
        )
        // TODO zrobić globalne pobieranie
        .then(({ data }) => {
          // @ts-ignore
          const blob = new Blob([data], { type: 'text/csv; charset=utf-8' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${this.getCurrentCart.name}.csv`
          // @ts-ignore
          link.click()
        })
    }

    onCartDelete() {
      this.$wait.start('cart-removing')
      this.$orderpath.cart.removeCart().then(() => {
        this.fetchDeliveryMethodsAndPaymentMethods()
        this.showDeleteModal = false
        this.$notify({
          group: 'alert',
          type: 'success',
          text: this.$t('cart.modals.cart_removed') as string,
        })
        setTimeout(() => {
          this.$wait.end('cart-removing')
        }, 150)
      })
    }

    onLoginModalHide() {
      this.showLoginModal = false
    }

    onCloseCampaignModal() {
      this.showCampaignModal = false
    }

    onDeliveryMethodChanged() {
      this.selectedPaymentMethod = null
      this.fetchDeliveryMethodsAndPaymentMethods()
    }

    getProductUrl(productId: string) {
      const product = this.getProductCart(productId)
      return product.url.trim() !== '' ? product.url : this.$routes.getProductUrl(product)
    }

    calculateProductsToReduceButNotRemove(
      product: AwardProductChanged,
      isMultiple: boolean | undefined,
    ) {
      if (isMultiple) {
        return (
          product.quantity + this.getTotalProductCountInCart(product.id, this.getCurrentCartId) >
            0 && !product.shouldBeRemoved
        )
      }

      return (
        product.quantity + this.getTotalProductCountInCart(product.id, this.getCurrentCartId) > 0
      )
    }

    calculateProductsToRemove(product: AwardProductChanged) {
      return (
        product.quantity + this.getTotalProductCountInCart(product.id, this.getCurrentCartId) <= 0
      )
    }

    async onAwardsUpdated(event: AwardsUpdateEvent) {
      this.showCampaignModal = false
      const productsToAdd: Array<Cart.Requests.AddProductToCart> = event.awardsAdded.map(
        (product: AwardProductChanged) => ({
          productId: product.id,
          amountOfProducts: product.quantity,
        }),
      )
      const productsToReduceButNotRemove: Array<Cart.Requests.AddProductToCart> =
        event.awardsDeleted
          .filter((product: AwardProductChanged) => {
            return this.calculateProductsToReduceButNotRemove(product, event.isMultiple)
          })
          .map((product: AwardProductChanged) => ({
            productId: product.id,
            amountOfProducts: event.isMultiple ? -product.quantity : product.quantity,
          }))
      const productsToRemove: ProductsToRemove[] = event.awardsDeleted
        .filter((product: AwardProductChanged) =>
          event.isMultiple ? product.shouldBeRemoved : this.calculateProductsToRemove(product),
        )
        .map((product: AwardProductChanged) => ({
          productId: product.id,
        }))
      if (productsToAdd.length || productsToReduceButNotRemove.length) {
        await this.addSelectedToCart(
          [...productsToAdd, ...productsToReduceButNotRemove],
          'cart-promotion',
        )
      }
      const findProductLineId = function (
        map: Map<string, Orderpath.App.Shared.ProductInCart>,
        productId: string,
      ): { productId: string; productLineId: string } {
        const result = [...map.values()].find((entry) => entry.id === productId)
        return { productId: result!.id, productLineId: result!.productLineId }
      }

      const productsToRemoveWithProductLineId: ProductsToRemove[] = productsToRemove.map((item) => {
        return findProductLineId(this.getCurrentCart.products, item.productId)
      })

      if (productsToRemove.length) {
        await this.removeSelectedProducts({
          cartId: this.getCurrentCartId,
          selectedProducts: productsToRemoveWithProductLineId,
        })
      }
      await this.fetchCurrentCart()
    }

    onProductEditClick(event: { pluginId: string; product: Shared.ProductInCart }) {
      const amountOfProducts: number = event.product.shipments
        .map((shipment: any) => shipment.numberOfProducts)
        .reduce(this.additiveReducer)
      try {
        const cartProducts: Array<Shared.ProductInCart> = Array.from(
          this.getCartProducts(this.getCurrentCartId).values(),
        )
        const context = new EditProductLinesOnCartContext(event.pluginId, this.$store, {
          productLineId: event.product.productLineId,
          meta: event.product.pluginData[event.pluginId],
          pluginProductLines: [],
          productLines: cartProducts,
          warehouseId: this.getDefaultWarehouseId,
          warehouses: this.getWarehousesList,
          cartId: this.getCurrentCartId,
          productId: event.product.id,
          productAmount: amountOfProducts,
        })
        context.onClose(() => {
          this.$api.orderpath.app.invalidate(['cart'])
          this.$orderpath.cart.fetchCart(this.getCurrentCartId)
          return false
        })
        context.open()
      } catch (e) {
        console.log(e)
      }
    }
  }
